export default function Heading({ children }) {
  return (
    <h1 className="text-xl text-center mx-auto mb-4 pb-1 px-4 border-b-4 w-fit ">
      {children}
    </h1>
  );
}
